// extracted by mini-css-extract-plugin
export default {"header":"header_header__Xrmhv","button":"header_button__8Wjfa","note":"header_note__BtBIV"};